// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"_3JTSG","active":"_GeTac","NavigationItemInner":"_2544m","NavigationImageWrapper":"_5ar6b","NavigationImage":"_V2K7H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.scss
// module id = 666
// module chunks = 0